import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.users_api.user_notifications;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// /GetAllUserNotificationsByUserId/<int:user_id>

export const getAllUserNotificationsByUserId = async (user_id: number) => {
    return await retryWithBackoff(() => api.get(`/GetAllUserNotificationsByUserId/${user_id}`));
    };



interface NotificationData {
    user_id: number;
    message: string;
    context: string;
    topic: string;
    data: any;
}

export const createNotification = async (notificationData:NotificationData) => {
    return await retryWithBackoff(() => api.post('/CreateNotification', notificationData));
}

// /MarkNotificationAsRead/<string:notification_id>

export const markNotificationAsRead = async (notification_id: string) => {
    return await retryWithBackoff(() => api.put(`/MarkNotificationAsRead/${notification_id}`));
};

// /DeleteAllUserNotifications/<int:user_id>

export const deleteAllUserNotifications = async (user_id: number) => {
    return await retryWithBackoff(() => api.delete(`/DeleteAllUserNotifications/${user_id}`));
};



